import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';
import {DialogService} from 'src/app/services/dialog.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  reCaptchaKey = environment.reCaptchaKey;
  enterpriseSelected = true;
  captchaFormGroup = null;
  validForm = false;
  email: string = null;
  validCaptcha = null;
  isValidEmail = null;
  reCaptchaResponse = '';
  resetSuccess = false;
  resetInProgress = false;
  accountExistError = false;
  termsAccepted = false;

  // emailRegexp = new RegExp(/\S+@\S+\.\S+/);
  emailRegexp = new RegExp(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i);

  constructor(
    private router: Router, private trustiiService: TrustiiService,
    private dialogService: DialogService, private sessionService: SessionService
  ) {
    document.body.style.backgroundImage = 'url("/assets/img/TrustiiHomePage.png")';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundSize = 'cover';
    this.captchaFormGroup = new FormGroup({
      captcha: new FormControl()
    });
  }

  ngOnInit() {
    if (this.sessionService.getUserType() == null) {
      this.router.navigateByUrl('');
    }
  }

  onEmailKey(e) {
    this.email = e.target.value;
    this.accountExistError = false;

    if (this.email.length === 0) {
      this.isValidEmail = null;
    } else if (this.emailRegexp.test(this.email)) {
      this.isValidEmail = true;
    } else {
      this.isValidEmail = false;
    }

    this.updateFormValidity();
  }

  askResetPassword(e) {
    if (!this.emailRegexp.test(this.email)) {
      this.dialogService.openAlertDialog(
        '350px',
        'Invalid email id',
        'ERROR',
        'Ok',
        'modal-negative'
      );
      return;
    }

    this.resetInProgress = true;
    const payload = {
      email: this.email,
      captchaKey: this.reCaptchaResponse,
    };
    this.trustiiService.askResetPassword(payload).subscribe(res => {
      this.resetSuccess = true;
      this.resetInProgress = false;
    }, err => {
      this.resetInProgress = false;
      this.dialogService.openAlertDialog(
        '350px',
        'Failed to reset your password. Please try again later.',
        'ERROR',
        'Ok',
        'modal-negative'
      );
    });
  }

  redirectToSignIn() {
    this.router.navigateByUrl('');
  }

  resolved(captchaResponse: string) {
    if (captchaResponse === null || captchaResponse.length === 0) {
      this.validCaptcha = false;
      this.updateFormValidity();
      return;
    }
    this.reCaptchaResponse = captchaResponse;
    this.validCaptcha = true;
    this.updateFormValidity();
  }

  updateFormValidity() {
    if (this.emailRegexp.test(this.email) && this.validCaptcha) {
      this.validForm = true;
    } else {
      this.validForm = false;
    }
  }
}
